import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, CartLineCollectionModel, CartLineCollectionModel>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    const isSalesBlockPresent = order.value.orderLines?.some(
        line => line.properties.salesBlocked?.toLowerCase() === "true",
    );

    if (isSalesBlockPresent) {
        props.apiParameter = {
            cartLines: order.value
                .orderLines!.filter(line => line.properties?.salesBlocked?.toLowerCase() !== "true")
                ?.map(
                    (line: OrderLineModel) =>
                        ({
                            productId: line.productId,
                            qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                            unitOfMeasure: line.unitOfMeasure,
                        } as CartLineModel),
                ),
        } as CartLineCollectionModel;
    } else {
        props.apiParameter = {
            cartLines: order.value.orderLines!.map(
                (line: OrderLineModel) =>
                    ({
                        productId: line.productId,
                        qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                        unitOfMeasure: line.unitOfMeasure,
                    } as CartLineModel),
            ),
        } as CartLineCollectionModel;
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);
